// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-group-modal .form-group {\n  margin: 0 0 10px 0;\n}\n.add-group-modal .form-group input {\n  width: 325px;\n}\n.add-group-modal .group-edit-image {\n  max-width: 300px;\n}", ""]);
// Exports
module.exports = exports;
